import React from 'react';
import * as Icons from '@ant-design/icons';
import { adminAPI } from '../../api';
import { isProductionEnv } from '../../index';

export const system = (match) => [
    {
        link: `${match.path}/admin-users`,
        icon: <Icons.TeamOutlined />,
        text: 'Admin users',
        key: 'admin-users',
        menuTab: 'admin-users'
    },
    {
        link: `${match.path}/sync`,
        icon: <Icons.SyncOutlined />,
        text: 'Sync',
        key: 'sync',
        menuTab: 'sync'
    },
    {
        link: `${match.path}/cron-jobs`,
        icon: <Icons.FieldTimeOutlined />,
        text: 'Cron Jobs',
        key: 'cron-jobs',
        menuTab: 'cron-jobs'
    },
    {
        link: `${match.path}/triple-whale-attribution`,
        icon: <Icons.FundOutlined />,
        text: 'TW Attribution Export',
        key: 'tw-attribution',
        menuTab: 'triple-whale-attribution'
    },
    {
        link: `${match.path}/priority-calculator`,
        icon: <Icons.CalculatorOutlined />,
        text: 'Priority Calculator',
        key: 'priority-calculator',
        menuTab: 'priority-calculator'
    },
    {
        link: `${match.path}/dsp/settings`,
        icon: <Icons.CodeSandboxOutlined />,
        text: 'DSP Settings',
        key: 'dsp-settings',
        menuTab: 'dsp-settings'
    },
    {
        link: `${match.path}/categorization-runs`,
        icon: <Icons.TagsOutlined />,
        text: 'Categorization runs',
        key: 'categorization-runs',
        menuTab: 'categorization-runs'
    },
    {
        // Moved here from the Brands section. The RBAC key stays `cpv2-orders-v2`
        // so existing access grants keep working (no backend access migration).
        link: `${match.path}/cpv2-orders?${new URLSearchParams({ limit: '10', page: '1' }).toString()}`,
        icon: <Icons.NodeIndexOutlined />,
        text: 'CP2',
        key: 'cpv2-orders-v2',
        menuTab: 'cpv2-orders'
    },
    { divider: true },
    {
        icon: <Icons.MonitorOutlined />,
        text: 'Workers monitor',
        key: 'workers-monitor',
        menuTab: 'workers-monitor',
        href: adminAPI.workers.monitor,
        target: '_blank'
    },
    ...(!isProductionEnv
        ? [
              {
                  icon: <Icons.CodeSandboxOutlined />,
                  text: 'GAB debugger',
                  key: 'gab-debugger',
                  menuTab: 'gab-debugger',
                  link: `${match.path}/gab-debugger`
              }
              // {
              //     link: `${match.path}/awa`,
              //     icon: <Icons.PieChartOutlined />,
              //     text: 'AWA',
              //     key: 'awa',
              //     menuTab: 'awa'
              // }
          ]
        : [])
];
